import { WaybillIdView } from '../../../../models';

export class ShipmentWaybillNotificationsLoad {
  public static readonly type = '[ShipmentWaybillNotifications] Load Notifications';
  constructor(public payload: WaybillIdView) {}
}

export class ShipmentWaybillNotificationsSetInitialState {
  public static readonly type = '[ShipmentWaybillNotifications] Set Initial State';
}
